import { addProjectsSaga } from './addProjects'
import { getAllProjectsSaga } from './getAllProjects'
import { getFiltredProjectsSaga } from './filtredProject'

const ProjectsSagas = [
    addProjectsSaga,
    getAllProjectsSaga,
    getFiltredProjectsSaga,
]

export default ProjectsSagas
